import { useMutation } from "@tanstack/react-query";

import { API } from "../../../bootstrap/api.ts";
import { router } from "../../../bootstrap/router.ts";
import { authSessionStore } from "../state/auth-session.ts";

interface AuthRedirectResult {
  readonly isPending: boolean;
  readonly redirect: () => void;
}

export function useAuthRedirect(): AuthRedirectResult {
  const getAuthRedirectUrl = useMutation({
    mutationFn: async ({ session }: { readonly session: string }) =>
      API.auth.getAuthRedirectUrl({
        returnUrl: `${window.location.origin}${router.getUrl("AuthCallback")}`,
        session,
      }),
  });

  return {
    isPending: getAuthRedirectUrl.isPending,
    redirect: () => {
      const session = authSessionStore.startSession();

      getAuthRedirectUrl.mutate(
        { session },
        {
          onSuccess: ({ redirectUrl }) => {
            window.location.href = redirectUrl;
          },
        },
      );
    },
  };
}
